import { accessRole } from "../../../../../helpers/access_role"
import { config } from "../../../../../helpers/config_global"
import React, { useState, Component, Fragment } from "react"
import { Redirect } from "react-router-dom"

import { Spinner, Table } from "reactstrap"

import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'

import { cancelToken } from "../../../../../services/adapters/kepegawaian/monitoringlemburService"

import DataTableBloc from '../Blocs/DataTableBloc'
import apiResponse from '../../../../../services/apiResponse'
import { Preview } from '../../../../../helpers/ui/FileInput'
import Shimmer from 'react-shimmer-effect'

import ReactTimeAgo from 'react-time-ago'
import moment from "moment"

import IndexBloc from "../Blocs/IndexBlock"
import MinioClient from '../../../../../services/minioClient'

class TableActiveComponent extends Component {
    minioClient = new MinioClient()
    dataTableBloc = new DataTableBloc();
    indexBloc = new IndexBloc();

    rupiah = (num) => {
        let res = "-";
        if (num != null && num != '') {
            res = parseFloat(num).toLocaleString('id-ID', { maximumFractionDigits: 2 })
        }
        return res;
    }
    files
    source
    historyTable = 'historyMonitoringLemburTableActive'
    defaultOrder = 'tanggal_lembur'
    defaultSize = 999999
    defaultSort = 'desc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            url: {},
            tooltip: false,
            detailUuid: null,
            syncUuid: null,
            updateUuid: null,
            inactiveUuid: null,
            defaultSize: 999999,
            rows: [],
            totalRow: 0,
            loadingTable: false,
            filter: sessionStorage.getItem(this.historyTable) ?
                JSON.parse(sessionStorage.getItem(this.historyTable)) :
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
                }
        }
        this.previewDocument = this.previewDocument.bind(this);
    }
    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

    dateParse = (input) => {
        let res = "-";
        if (input != "" && input != null) {
            res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    exportExcel = () => {
        let additionalFilter = this.props.additionalFilter;
        this.indexBloc.fetchExport({
            ...additionalFilter
        });
    }

    loadData = async () => {
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        let additionalFilter = this.props.additionalFilter;

        /* kirim ke server */
        let offset = (this.state.filter.page_number - 1) * this.state.filter.page_size
        if (this.state.defaultSize !== this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1,
            ...additionalFilter
        }
        await this.dataTableBloc.fetchRowTable(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    confirmResponse = (response) => {
        let forState = {}
        switch (response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.syncData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
            case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:
        }
        this.setState(forState)
    }

    inactiveData = async () => {
        await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid })
    }

    componentDidMount() {
        // this.setTokenAPI()

        this.dataTableBloc.rowtableChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })

        this.indexBloc.exportChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.LOADING:
                    this.setState({
                        loading: true,
                    })
                    break
                case apiResponse.COMPLETED:
                    const link = result.data.response
                    window.open(link.file_url, "_blank")
                    this.setState({
                        loading: false,
                        success: true
                    })
                    setTimeout(() => {
                        this.setState({
                            success: false,
                        })
                    }, 1000);
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true
                    })
                    setTimeout(function () {
                        this.setState({
                            failed: false,
                        })
                    }, 1000)
                    break
                default:
                    break
            }
        })
    }

    componentWillUnmount() {
        this.dataTableBloc.rowtableChannel.unsubscribe()
        this.indexBloc.exportChannel.unsubscribe()
    }

    previewDocument(urlPath) {
        this.setState({
           loading: true
        })
        this.minioClient.get(urlPath).then((url) => {
            this.setState({
                loading: false
             })
           window.open(url, "_blank")
        })
    }

    render() {
        return (
            <>

                <div className="table-responsive">
                    <Table
                        className="table table-striped table-bordered table-hover"
                    >
                        <thead className="table-primary">
                            <tr>
                                <th rowspan="2" className="align-middle text-center" width="*">No</th>
                                <th rowspan="2" className="align-middle text-center" width="*">Pegawai</th>
                                <th rowspan="2" className="align-middle text-center" width="*">Surat Tugas</th>
                                <th rowspan="2" className="align-middle text-center" width="*">Tanggal Lembur</th>
                                <th colspan="2" className="align-middle text-center" width="*">Jam Surat</th>
                                <th colspan="2" className="align-middle text-center" width="*">Absen</th>
                                <th colspan="2" className="align-middle text-center" width="*">Jam Lembur</th>
                            </tr>
                            <tr>
                                <th className="align-middle text-center">Masuk</th>
                                <th className="align-middle text-center">Pulang</th>
                                <th className="align-middle text-center">Masuk</th>
                                <th className="align-middle text-center">Pulang</th>
                                <th className="align-middle text-center">Masuk</th>
                                <th className="align-middle text-center">Pulang</th>
                            </tr>
                        </thead>
                        <tbody>
                            
                            {
                                this.state.loadingTable == false ?
                                    this.state.rows.length > 0 ?
                                        
                                        this.state.rows.map((data, index) => {
                                            return (
                                                <tr>
                                                    <td>{index += 1}</td>
                                                    <td>
                                                        <b>{data.employee_nip}</b> <br />{data.employee_full_name} <br />
                                                    </td>
                                                    <td>
                                                        Tanggal : <b>{this.dateParse(data.overtime_st_date)}</b> <br />
                                                        Nomor : <a href="javascript:void(0);" onClick={() => {
                                                            this.previewDocument(data.documents_path)
                                                        }}>{data.overtime_st_number}</a> <br />
                                                        
                                                    </td>
                                                    <td>{data.hari_lembur === null ? '-' : data.hari_lembur}<br />{this.dateParse(data.tanggal_lembur)}</td>
                                                    <td className="text-center">{data.overtime_start_time === null ? '-' : data.overtime_start_time}</td>
                                                    <td className="text-center">{data.overtime_end_time === null ? '-' : data.overtime_end_time}</td>
                                                    <td className="text-center">{data.jam_masuk === null ? '-' : data.jam_masuk}</td>
                                                    <td className="text-center">{data.jam_keluar === null ? '-' : data.jam_keluar}</td>
                                                    <td className="text-center">{data.jam_masuk_perhitungan === null ? '-' : data.jam_masuk_perhitungan}</td>
                                                    <td className="text-center">{data.jam_keluar_perhitungan === null ? '-' : data.jam_keluar_perhitungan}</td>                                                                                                   
                                                </tr>
                                            );
                                        })
                                        :
                                        <tr>
                                            <td colSpan="10" className="text-center">Tidak Ada Data</td>
                                        </tr>
                                    :
                                    <tr>
                                        <td colSpan="10" className="text-center"><Spinner className="m-2" color="primary" /></td>
                                    </tr>
                            }
                        </tbody>
                    </Table>
                </div>

                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan melakukan sinkronisasi data ini?"

                    loadingTitle="Memproses data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil diproses"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal diproses"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                {this.state.detailUuid !== null ?
                    // <Redirect to={"/sample.html?detail&uuid=" + this.state.detailUuid}/>
                    <Redirect to={"/kepegawaian/rekap_absensi.html?detail&uuid=" + this.state.detailUuid} />
                    : null}
            </>
        )
    }

}

export default TableActiveComponent